export default "__VITE_ASSET__93952235__"